module.exports = __webpack_public_path__ + "static/singleContentBlockFront-95d8746bf1517653d9b80f4778535edf.png";